/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import request, { ContentType, RequestParams } from './httpClient'
import {
  DomainCategoryStatResp,
  DomainSourceStatResp,
  DomainStatResp,
  DomainTimeStatResp,
  GetAdminStatCategoryParams,
  GetAdminStatTimeParams,
  WebResp,
} from './types'

/**
 * @description 总统计
 *
 * @tags AdminStatV1
 * @name GetAdminStat
 * @summary 总统计
 * @request GET:/api/v1/admin/statistics
 * @response `200` `(WebResp & {
    data?: DomainStatResp,

})` OK
 */

export const getAdminStat = (params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainStatResp
    }
  >({
    path: `/api/v1/admin/statistics`,
    method: 'GET',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 来源统计数据
 *
 * @tags AdminStatV1
 * @name GetAdminSourceStat
 * @summary 来源统计数据
 * @request GET:/api/v1/admin/statistics/source
 * @response `200` `(WebResp & {
    data?: DomainSourceStatResp,

})` OK
 */

export const getAdminSourceStat = (params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainSourceStatResp
    }
  >({
    path: `/api/v1/admin/statistics/source`,
    method: 'GET',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 分类统计数据
 *
 * @tags AdminStatV1
 * @name GetAdminStatCategory
 * @summary 分类统计数据
 * @request GET:/api/v1/admin/statistics/category
 * @response `200` `(WebResp & {
    data?: DomainCategoryStatResp,

})` OK
 */

export const getAdminStatCategory = (query: GetAdminStatCategoryParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainCategoryStatResp
    }
  >({
    path: `/api/v1/admin/statistics/category`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 拆线图数据
 *
 * @tags AdminStatV1
 * @name GetAdminStatTime
 * @summary 拆线图数据
 * @request GET:/api/v1/admin/statistics/time
 * @response `200` `(WebResp & {
    data?: DomainTimeStatResp,

})` OK
 */

export const getAdminStatTime = (query: GetAdminStatTimeParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainTimeStatResp
    }
  >({
    path: `/api/v1/admin/statistics/time`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
